module.exports = __webpack_public_path__ + "img/pdf-icon.df36090a.png";